export const StandardizedCategoryDocumentIDDefault = 'default';
export type StandardizedCategoryDocumentID = string | 'default';

export interface StandardizedCategory {
  documentID: string;
  id: string;
  hidden: boolean;
  sortIndex: number;
  level: number;
  parentDocumentID?: string;
  unmatchable?: boolean;
}
